module.exports = __webpack_public_path__ + "img/sosial@2x.1cd31b97.png";